var map = {
	"./data-search.de-CH.json": 1011,
	"./data-search.de-DE.json": 1012,
	"./data-search.en-CA.json": 1013,
	"./data-search.en-GB.json": 1014,
	"./data-search.en-IN.json": 1015,
	"./data-search.en-ME.json": 1016,
	"./data-search.en-US.json": 1017,
	"./data-search.es-EM.json": 1018,
	"./data-search.es-ES.json": 1019,
	"./data-search.fr-BE.json": 1020,
	"./data-search.fr-CA.json": 1021,
	"./data-search.fr-CH.json": 1022,
	"./data-search.nl-BE.json": 1023,
	"./data-search.nl-NL.json": 1024,
	"./data-search.pl-PL.json": 1025,
	"./data-search.pt-BR.json": 1026
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1010;